package io.janni.wedding

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.background
import com.varabyte.kobweb.silk.theme.colors.palette.color

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 */
class SitePalette(
    val background: Color,
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {
    class Brand(
        val primary: Color = Color.rgb(0x7F8774),
        val accent: Color = Color.rgb(0xBBA470),
    )
}

object SitePalettes {
    val light = SitePalette(
        background = Color.rgb(0xEAE9EC),
        nearBackground = Color.rgb(0xDCDBE0),
        cobweb = Color.rgb(0xA2A087),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x7F8774),
            accent = Color.rgb(0xBBA470),
        )
    )
    val dark = SitePalette(
        background = Color.rgb(0xEAE9EC).inverted(),
//        background = Color.rgb(0x4B4444),
//        nearBackground = Color.rgb(0x837676),
        nearBackground = Color.rgb(0xDCDBE0).inverted(),
        cobweb = Color.rgb(0xA2A087).inverted(),
        brand = SitePalette.Brand(
            primary = Color.rgb(0x7F8774),
            accent = Color.rgb(0xBBA470),
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette = when (this) {
    ColorMode.LIGHT -> SitePalettes.light
    ColorMode.DARK -> SitePalettes.dark
}

@InitSilk
fun initTheme(ctx: InitSilkContext) {
    ctx.theme.palettes.light.background = SitePalettes.light.background
    ctx.theme.palettes.light.color = Colors.White.copy(alpha = (0.9.coerceIn(0.0, 1.0) * 255.0f).toInt())
    ctx.theme.palettes.dark.background = SitePalettes.dark.background
    ctx.theme.palettes.dark.color = Colors.White
}
